import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';

import theme from 'src/styles/components/OrderAddon.module.scss';

// eslint-disable-next-line import/no-cycle
import OrderAddons from './OrderAddons';

const OrderAddon = React.memo(({
    addonGroupName,
    name,
    quantity,
    price,
    addons
}) => {
    const intl = useIntl();

    return (
        <div>
            <div className={theme.categoryName}>
                {addonGroupName}
            </div>
            <div className={theme.name}>
                {name}
                {quantity > 1 && ` ${quantity} ${intl.formatMessage({ id: 'App.pcs' })}`}
                {price > 0 && ` (${intl.formatNumber(price, { style: 'currency', currency: 'PLN' })})`}
            </div>
            {addons && <OrderAddons addons={addons} />}
        </div>
    );
});

OrderAddon.propTypes = {
    addonGroupName: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    quantity: PropTypes.number.isRequired,
    price: PropTypes.number.isRequired,
    addons: PropTypes.arrayOf(PropTypes.object)
};

export default OrderAddon;
